import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function SelectInput({
  children,
  value,
  onChange,
  disabled,
  className,
  sx,
  style,
  fullWidth,
  ...inputProps
}) {
  const rootRef = React.useRef(null);
  const [menuHeight, setMenuHeight] = React.useState(240);
  return (
    <Select
      ref={rootRef}
      onOpen={() =>
        setMenuHeight(
          Math.max(
            0,
            Math.min(
              240,
              window.innerHeight -
                rootRef.current.getBoundingClientRect().bottom -
                16,
            ),
          ),
        )
      }
      MenuProps={{
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        slotProps: { paper: { sx: { maxHeight: menuHeight } } },
      }}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={className}
      sx={sx}
      style={style}
      fullWidth={fullWidth}
      inputProps={inputProps}
      SelectDisplayProps={{ "aria-label": inputProps["aria-label"] }}
    >
      {React.Children.map(children, (option) => (
        <MenuItem value={option.props.value} disabled={option.props.disabled}>
          {option.props.children || "None"}
        </MenuItem>
      ))}
    </Select>
  );
}
